import Model from './Model';
import validator from '../../validator';

export interface ICherriesForm {
  email: string;
  telno: string;
  name: string;
  amount: number;
  order_time: string;
  postal: string;
  date: string;
  device: string;
  address: string;
  message: string;
  boxes: number;
  saveDetails: boolean;
}

class CherriesForm extends Model {
  email: string;
  telno: string;
  name: string;
  amount: number;
  orderTime: string;
  postal: string;
  date: string;
  device: string;
  address: string;
  message: string;
  boxes: number;
  saveDetails: boolean;

  constructor(data?: ICherriesForm) {
    super();
    this.email = data?.email ?? '';
    this.telno = data?.telno ?? '';
    this.name = data?.name ?? '';
    this.amount = data?.amount ?? 1;
    this.orderTime = data?.order_time ?? '';
    this.postal = data?.postal ?? '';
    this.date = data?.date ?? '';
    this.device = data?.device ?? 'IPAD';
    this.address = data?.address ?? '';
    this.message = data?.message ?? '';
    this.boxes = data?.boxes ?? 0;
    this.saveDetails = data?.saveDetails ?? false;


    this.validation = {
      email: validator.email('Vul uw e-mail in.'),
      name: validator.input('Vul uw naam in.'),
      address: validator.input('Vul uw adres in.'),
      postal: validator.input('Vul uw postcode in.'),
      telno: validator.telno('Vul uw telefoonnummer in.'),
    };

    validator.initialiseValidation(this, this.validation);

    // TODO: auto increment boxes
    // observe(this, 'amount' , ({ newValue }) => {
    //   this.boxes = parseInt(Math.floor(parseInt(newValue) / 6).toFixed(1));
    // });
  }

  toJSON = () => {
    return {
      email: this.email,
      telno: this.telno,
      address: this.address,
      name: this.name,
      amount: parseInt(`${this.amount}`),
      date: this.date,
      device: this.device,
      order_time: this.orderTime,
      message: this.message,
      saveDetails: this.saveDetails,
      postal: this.postal,
      boxes: this.boxes,
    }
  }
}

export default CherriesForm


